import { render, staticRenderFns } from "./LayoutContentRendererLeftDetached.vue?vue&type=template&id=197fe5dd"
import script from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentRendererLeftDetached.vue?vue&type=style&index=0&id=197fe5dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports